// components/parametres/TablesRefTab.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const TablesRefTab = () => {
  const [typesClients, setTypesClients] = useState([]);
  const [motifsRejet, setMotifsRejet]   = useState([]);
  const [especes, setEspeces]           = useState([]);
  const [chargement, setChargement]     = useState(true);
  const [message, setMessage]           = useState(null);

  // Formulaires d'ajout
  const [newTypeClient, setNewTypeClient] = useState({ code: '', nom: '' });
  const [newMotif, setNewMotif]           = useState({ code: '', nom: '' });

  useEffect(() => {
    const charger = async () => {
      try {
        const [resTC, resMR, resE] = await Promise.all([
          api.get('/parametres/types-clients'),
          api.get('/parametres/motifs-rejet'),
          api.get('/parametres/especes'),
        ]);
        setTypesClients(resTC.data);
        setMotifsRejet(resMR.data);
        setEspeces(resE.data);
      } catch (err) {
        setMessage({ type: 'erreur', texte: 'Erreur de chargement.' });
      } finally {
        setChargement(false);
      }
    };
    charger();
  }, []);

  const ajouterTypeClient = async () => {
    if (!newTypeClient.code || !newTypeClient.nom) return;
    try {
      const res = await api.post('/parametres/types-clients', newTypeClient);
      setTypesClients(prev => [...prev, res.data]);
      setNewTypeClient({ code: '', nom: '' });
      setMessage({ type: 'succes', texte: 'Type client ajouté.' });
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur serveur.' });
    }
  };

  const supprimerTypeClient = async (id) => {
    if (!window.confirm('Supprimer ce type client ?')) return;
    try {
      await api.delete(`/parametres/types-clients/${id}`);
      setTypesClients(prev => prev.filter(t => t.id !== id));
      setMessage({ type: 'succes', texte: 'Supprimé avec succès.' });
    } catch (err) {
      setMessage({ type: 'erreur', texte: 'Erreur lors de la suppression.' });
    }
  };

  const ajouterMotif = async () => {
    if (!newMotif.code || !newMotif.nom) return;
    try {
      const res = await api.post('/parametres/motifs-rejet', newMotif);
      setMotifsRejet(prev => [...prev, res.data]);
      setNewMotif({ code: '', nom: '' });
      setMessage({ type: 'succes', texte: 'Motif ajouté.' });
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur serveur.' });
    }
  };

  const supprimerMotif = async (id) => {
    if (!window.confirm('Supprimer ce motif ?')) return;
    try {
      await api.delete(`/parametres/motifs-rejet/${id}`);
      setMotifsRejet(prev => prev.filter(m => m.id !== id));
      setMessage({ type: 'succes', texte: 'Supprimé avec succès.' });
    } catch (err) {
      setMessage({ type: 'erreur', texte: 'Erreur lors de la suppression.' });
    }
  };

  const styles = {
    container:   { display: 'flex', flexDirection: 'column', gap: 24 },
    card:        { background: 'white', borderRadius: 8, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
    titre:       { fontSize: 16, fontWeight: 700, color: '#1a5c2a', marginBottom: 16 },
    table:       { width: '100%', borderCollapse: 'collapse', fontSize: 14, marginBottom: 16 },
    th:          { background: '#f3f4f6', padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#374151', borderBottom: '2px solid #e5e7eb' },
    td:          { padding: '8px 12px', borderBottom: '1px solid #f3f4f6', color: '#374151' },
    badge:       { display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600, background: '#dbeafe', color: '#1e40af' },
    badgeVert:   { display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 600, background: '#d1fae5', color: '#065f46' },
    row:         { display: 'flex', gap: 10, alignItems: 'center', marginTop: 8 },
    input:       { padding: '7px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, flex: 1 },
    btnAjouter:  { padding: '7px 18px', background: '#1a5c2a', color: 'white', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' },
    btnSuppr:    { padding: '4px 10px', background: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: 4, fontSize: 12, cursor: 'pointer' },
    msgSucces:   { padding: '10px 16px', background: '#d1fae5', color: '#065f46', borderRadius: 6, fontSize: 14, marginBottom: 16 },
    msgErreur:   { padding: '10px 16px', background: '#fee2e2', color: '#991b1b', borderRadius: 6, fontSize: 14, marginBottom: 16 },
    sousTitre:   { fontSize: 13, color: '#6b7280', marginBottom: 12 },
  };

  if (chargement) return <p style={{ color: '#6b7280', padding: 24 }}>Chargement...</p>;

  return (
    <div style={styles.container}>

      {message && (
        <div style={message.type === 'succes' ? styles.msgSucces : styles.msgErreur}>
          {message.texte}
        </div>
      )}

      {/* ── Espèces (lecture seule) ── */}
      <div style={styles.card}>
        <div style={styles.titre}>🐄 Espèces animales</div>
        <p style={styles.sousTitre}>Liste fixe des espèces gérées par SOGAS.</p>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Code</th>
              <th style={styles.th}>Nom</th>
              <th style={styles.th}>Statut</th>
            </tr>
          </thead>
          <tbody>
            {especes.map(e => (
              <tr key={e.id}>
                <td style={styles.td}><span style={styles.badge}>{e.code}</span></td>
                <td style={styles.td}>{e.nom}</td>
                <td style={styles.td}><span style={styles.badgeVert}>Actif</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Types clients ── */}
      <div style={styles.card}>
        <div style={styles.titre}>👤 Types de clients</div>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Code</th>
              <th style={styles.th}>Nom</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {typesClients.map(t => (
              <tr key={t.id}>
                <td style={styles.td}><span style={styles.badge}>{t.code}</span></td>
                <td style={styles.td}>{t.nom}</td>
                <td style={styles.td}>
                  <button
                    style={styles.btnSuppr}
                    onClick={() => supprimerTypeClient(t.id)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Ajout */}
        <div style={styles.row}>
          <input
            style={styles.input}
            placeholder="Code (ex: GROSSISTE)"
            value={newTypeClient.code}
            onChange={e => setNewTypeClient(p => ({ ...p, code: e.target.value.toUpperCase() }))}
          />
          <input
            style={styles.input}
            placeholder="Nom (ex: Grossiste)"
            value={newTypeClient.nom}
            onChange={e => setNewTypeClient(p => ({ ...p, nom: e.target.value }))}
          />
          <button style={styles.btnAjouter} onClick={ajouterTypeClient}>+ Ajouter</button>
        </div>
      </div>

      {/* ── Motifs de rejet ── */}
      <div style={styles.card}>
        <div style={styles.titre}>🚫 Motifs de rejet</div>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Code</th>
              <th style={styles.th}>Nom</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {motifsRejet.map(m => (
              <tr key={m.id}>
                <td style={styles.td}><span style={{ ...styles.badge, background: '#fef3c7', color: '#92400e' }}>{m.code}</span></td>
                <td style={styles.td}>{m.nom}</td>
                <td style={styles.td}>
                  <button
                    style={styles.btnSuppr}
                    onClick={() => supprimerMotif(m.id)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Ajout */}
        <div style={styles.row}>
          <input
            style={styles.input}
            placeholder="Code (ex: FRACTURE)"
            value={newMotif.code}
            onChange={e => setNewMotif(p => ({ ...p, code: e.target.value.toUpperCase() }))}
          />
          <input
            style={styles.input}
            placeholder="Nom (ex: Fracture)"
            value={newMotif.nom}
            onChange={e => setNewMotif(p => ({ ...p, nom: e.target.value }))}
          />
          <button style={styles.btnAjouter} onClick={ajouterMotif}>+ Ajouter</button>
        </div>
      </div>

    </div>
  );
};

export default TablesRefTab;
